import React, { useEffect } from 'react';
import { locales } from '../../../translations/locales';
import Categories from './Categories';
import Incidents from './Incidents';
import Places from './Places';
import ResumeQualification from './ResumeQualification';
import { FaChevronRight } from 'react-icons/fa6';


const Qualification = (props) => {
    const {
        locale,
        menu,
        setMenu,
        theme,
        setQualification,
        qualification,
        location,
        incidentsCategories,
        incidents,
        updatedQualification,
        onChangeQualification,
        setUpdatedQualification,
        places,
    } = props;

    useEffect(() => {
        if (qualification) {
            setUpdatedQualification(qualification);
        }
    }, [qualification, updatedQualification]);

    return (
        location && !qualification ? (
            <div className={`col-${menu === 'Qualification' ? '8' : '4'}`} onClick={() => setMenu('Qualification')}>
                <div className={`alert alert-${theme === 'DARK' ? 'dark' : 'light'}`}>
                    <h5 className='alert-heading'>{locales[locale].sga.qualification}</h5>
                    <div className='row'>
                        {

                            !updatedQualification.qualification ? (
                                <>
                                    <Categories
                                        locale={locale}
                                        incidentsCategories={incidentsCategories}
                                        onChangeQualification={onChangeQualification}
                                        categorySelected={updatedQualification.category}
                                    />
                                    <Incidents
                                        incidents={incidents}
                                        category={updatedQualification.category}
                                        qualification={updatedQualification.qualification}
                                        onChangeQualification={onChangeQualification}
                                    />
                                </>
                            ) : (
                                <div className='col-12'>
                                    <ResumeQualification
                                        locale={locale}
                                        category={updatedQualification.category}
                                        qualification={updatedQualification.qualification}
                                        onChangeQualification={onChangeQualification}
                                    />
                                    <Places
                                        locale={locale}
                                        theme={theme}
                                        places={places}
                                        onChangeQualification={onChangeQualification}
                                    />
                                </div>
                            )
                        }
                    </div>
                    <div className='form-group'>
                        <label htmlFor='informations'>{locales[locale].sga.informations}</label>
                        <textarea
                            className='form-control'
                            id='informations'
                            rows='3'
                            value={updatedQualification.informations}
                            onChange={onChangeQualification}
                        ></textarea>
                    </div>
                    <div className='form-check text-right'>
                        <button
                            className='btn btn-primary btn-sm m-2 pl-4 pr-4'
                            onClick={() => setQualification(true)}
                        >
                            {locales[locale].sga.validate}
                        </button>
                    </div>
                </div>
            </div>
        ) : !location ? (
            <div className={`col-${menu === 'Qualification' ? '8' : '4'}`} onClick={() => setMenu('Qualification')}>
                <div className={`alert alert-${theme === 'DARK' ? 'dark' : 'light'}`}>
                    <h5 className='alert-heading'>{locales[locale].sga.qualification}</h5>
                    {locales[locale].sga.waitingLocation}
                </div>
            </div>
        ) : (
            <div className={`col-${menu === 'Location' ? '8' : '4'}`} onClick={() => setMenu('Qualification')}>
                <div className={`alert alert-${theme === 'DARK' ? 'dark' : 'light'}`}>
                    <h5 className='alert-heading'>{locales[locale].sga.qualification}</h5>
                    <p>{locales[locale].sga[qualification.category]} <FaChevronRight className='mb-1' /> {qualification.qualification}</p>
                    <p>
                        {locales[locale].sig[updatedQualification.place.category]}
                        <FaChevronRight className='m-1' />
                        {locales[locale].sig[updatedQualification.place.type]}
                    </p>
                    <label htmlFor='observations'>{locales[locale].sga.informations}</label>
                    <textarea className='form-control' id='observations' rows='3' value={qualification.informations} disabled></textarea>
                    <div className='form-check text-right'>
                        <button className='btn btn-primary btn-sm m-2 pl-4 pr-4' onClick={() => setQualification(false)}>
                            {locales[locale].sga.update}
                        </button>
                    </div>
                </div>
            </div>
        )
    );
};

export default Qualification;
